import type { GameContext } from '../../engine/core/GameContext';

/**
 * 空场提速（[游戏设计](../../../docs/游戏设计.md#通关与节奏)）：空中数量低于阈值时下落提速，
 * 压掉收尾空档。**只在低于阈值且没有波段在投时生效**，正常交战期完全不介入——否则「放着不管
 * 等它掉下去」会变成比打掉它更快的通关手段，玩家被奖励不开枪。波段在投时同样不介入：大波里一次
 * 大连锁把空中清到阈值以下，剩下的若因此加速，打得越好的人死得越快，且波段自己还在往下投。
 *
 * 也不看数量地一票否决：`dangerLine` 以下（靠近红线的下半区）只要还有一只在空中，就不提速——
 * 少量史莱姆已经压到下面时再加速，玩家感受到的不是「收尾变快」而是「突然要输」。
 *
 * 倍率在阈值处为 1、线性升到空场时的 `max`，写进 `state.paceMultiplier`，由物理乘在重力上。
 * 归关卡规则而不是世界规则：它与波次表是一套节奏配置，坐标表关卡与测试 Fixture 不该被它改变落速。
 */
export function runEmptyFieldPace(context: GameContext, params: Record<string, unknown>): void {
  const threshold = typeof params.threshold === 'number' ? params.threshold : 0;
  const max = typeof params.max === 'number' ? params.max : 1;
  const dangerLine = typeof params.dangerLine === 'number' ? params.dangerLine : Number.POSITIVE_INFINITY;
  const { slimes, level, state, spawn } = context;
  if (threshold <= 0 || max <= 1 || spawn.waveIndex >= 0) { state.paceMultiplier = 1; return; }
  let airborne = 0;
  let danger = false;
  for (let id = 0; id < slimes.capacity; id += 1) {
    if (slimes.active[id] === 0 || slimes.isDying(id) || slimes.y[id] > level.world.leakLine) continue;
    airborne += 1;
    if (slimes.y[id] > dangerLine) danger = true;
  }
  state.paceMultiplier = danger || airborne >= threshold ? 1 : 1 + ((threshold - airborne) / threshold) * (max - 1);
}
